import React, { useEffect, useState } from "react";

const OfflineBanner: React.FC = () => {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" && navigator.onLine === false
  );

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100000,
        backgroundColor: "#005e34",
        color: "white",
        padding: "10px 16px",
        textAlign: "center",
        fontSize: 14,
        fontFamily: "sans-serif",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      }}
    >
      Du bist offline. Einige Funktionen sind nicht verfügbar.
    </div>
  );
};

export default OfflineBanner;
